import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Remove Emergent badge injected by deployment infrastructure
(function removeBadge() {
  function remove() {
    var el = document.getElementById('emergent-badge');
    if (el) el.parentNode.removeChild(el);
    // Also remove posthog script
    document.querySelectorAll('script[src*="emergent"]').forEach(function(s) { s.parentNode.removeChild(s); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', remove);
  } else {
    remove();
  }
  // Keep checking in case it's injected after load
  setTimeout(remove, 500);
  setTimeout(remove, 2000);
  setTimeout(remove, 5000);
})();
